export const liveScoreboard = {
  settings: {
    title: "Live Match",
    subtitle: "Configure your match format",
    matchCategory: "Match Category",
    categories: {
      mens_singles: "Men's Singles",
      womens_singles: "Women's Singles",
      mens_doubles: "Men's Doubles",
      womens_doubles: "Women's Doubles",
      mixed_doubles: "Mixed Doubles",
    },
    matchFormat: "Match Length",
    bestOf1: "1 Set",
    bestOf3: "Best of 3",
    bestOf5: "Best of 5",
    gamesPerSet: "Games per Set",
    gamesPerSetHint: "Standard sets are first to 6. 4-game sets are common in club / amateur play. Tiebreak = super tiebreak decides the whole match.",
    games6: "First to 6",
    games4: "First to 4",
    gamesTiebreak: "Match Tiebreak",
    deuceRule: "Deuce Rule (40-40)",
    deuceRuleHint: "Golden point ends the deuce immediately — next point wins. Advantage requires winning by 2.",
    deuce: {
      advantage: "Advantage",
      goldenPoint: "Golden Point",
    },
    tiebreak: "Tiebreak Format",
    points7: "First to 7",
    points10: "First to 10",
    summary: "Match Summary",
    format: "Format",
    bestOf: "Best of",
    sets: "Sets",
    points: "Points",
    startMatch: "Start Match",
    backToHome: "Back to Home",
  },

  scoreboard: {
    liveMatch: "Live Match",
    tiebreak: "Tiebreak",
    pts: "pts",
    sets: "Sets",
    games: "Games",
    points: "Points",
    tiebreakPoints: "Tiebreak Points",
    point: "Point",
    switchServer: "Switch Server",
    shareMatch: "Share Live Match",
    linkCopied: "Link copied to clipboard",
    spectatorBadge: "LIVE",
  },

  matchComplete: {
    title: "Match Complete!",
    congratulations: "Congratulations to the winner",
    winner: "Winner",
    setScores: "Set Scores",
    set: "Set",
    saveThisMatch: "Save This Match?",
    saveMatchDescription: "Would you like to add this match to your records?",
    saveToRecords: "Save to Records",
    discardMatch: "Discard Match",
    startNewMatch: "Start New Match",
  },
};
